import Swiper, {Navigation, EffectFade, Autoplay, Pagination} from 'swiper';

//

const testimonialSlider = document.querySelector('.front-testimonials__swiper')
if ( testimonialSlider ) {
	const testimonialSliderSwiper = new Swiper(".front-testimonials__swiper", {
		modules: [Navigation, EffectFade, Autoplay],
		slidesPerView: 1,
		navigation: {
			nextEl: ".front-testimonials__swiper-button-next",
			prevEl: ".front-testimonials__swiper-button-prev",
		},
		loop: true,
		autoplay: {
			delay: 9000,
		},
	});
}

// activate procedures slider
const proceduresSlider = document.querySelector('.front-procedures-slider-swiper');
if ( proceduresSlider ) {
	const proceduresSliderSwiper = new Swiper ('.front-procedures-slider-swiper', {
		modules: [Navigation, EffectFade, Autoplay, Pagination],
		// Optional parameters
		slidesPerView: 1,
		centeredSlides: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
			transformEl: '.front-procedures-slider__single'
		},
		speed: 0,
		navigation: {
			nextEl: ".front-procedures-slider .swiper-next",
			prevEl: ".front-procedures-slider .swiper-prev",
		},
		pagination: {
			el: '.front-procedures-slider .swiper-pagination',
			clickable: true,
		},
		// Enable autoHeight
		autoHeight: true,
		loop: true,
		autoplay: false,
	});
}




